import styled from 'styled-components'

export const SitesTableWrapper = styled.div`
  margin: 0 56px 32px 56px;

  td:nth-child(1) {
    min-width: 40px;
    max-width: 40px;
  }

  td:nth-child(2) {
    min-width: 125px;
    max-width: 125px;
  }

  td:nth-child(3) {
    min-width: 300px;
  }

  td:nth-child(4) {
    min-width: 116px;
    max-width: 116px;
  }

  td:nth-child(5) {
    min-width: 100px;
    max-width: 100px;
  }

  td:nth-child(6) {
    min-width: 300px;
  }

  td:nth-child(7) {
    min-width: 175px;
    max-width: 175px;
  }
  td:nth-child(8) {
    min-width: 175px;
    max-width: 175px;
  }
  td:nth-child(9) {
    min-width: 125px;
    max-width: 125px;
  }
  td:nth-child(10) {
    min-width: 100px;
    max-width: 100px;
  }
    td:nth-child(11) {
    min-width: 100px;
    max-width: 100px;
  }
    td:nth-child(12) {
    min-width: 100px;
    max-width: 100px;
  }
`

export const SitesFooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0 32px 0;
`

const SitesTableIcon = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-right: 12px;
  display: inline-block;
`
export const SitesTableUnderAssessmentIcon = styled(SitesTableIcon)`
  background: #7e57c2;
`

export const SitesTableIconDraft = styled(SitesTableIcon)`
  background: #e65100;
`

export const SitesTableIconEditOnly = styled(SitesTableIcon)`
  background: rgba(103, 58, 183, 1);
`

export const SitesTableIconProposed = styled(SitesTableIcon)`
  background: rgba(10, 161, 244, 1);
`

export const SitesTableIconReviewedRFP = styled(SitesTableIcon)`
  background: rgba(146, 191, 0, 1);
`

export const SitesTableIconNominated = styled(SitesTableIcon)`
  background: rgb(255, 153, 0);
`

export const SitesTableIconConfirmed = styled(SitesTableIcon)`
  background: rgba(5, 148, 79, 1);
`

export const SitesTableIconSuperseded = styled(SitesTableIcon)`
  background: rgb(239, 85, 137);
`

/** Distinct from draft (orange): deep red + inner dot = delisted */
export const SitesTableIconDelistedWrapper = styled(SitesTableIcon)`
  background: #b71c1c;
`

export const SitesTableIconNotQualifyWrapper = styled(SitesTableIcon)`
  background: rgba(32, 32, 32, 1);
`

export const SitesTableIconEditOnlyWrapper = styled(SitesTableIcon)`
  background: rgba(30, 144, 255, 0.6);
`

/** @deprecated use SitesTableIconSubmittedEdits — kept for any legacy imports */
export const SitesTableIconProposedEditOnlyWrapper = styled(SitesTableIcon)`
  background: #006064;
`

/** Submitted edits — teal, distinct from edit-only purple and proposed blue */
export const SitesTableIconSubmittedEdits = styled(SitesTableIcon)`
  background: #00838f;
`

/** Not assessed — ring style, distinct from filled dots */
export const SitesTableIconNotAssessed = styled(SitesTableIcon)`
  background: transparent;
  border: 2px solid #455a64;
  box-sizing: border-box;
`

export const SiteTableIconDelisted = styled.div`
  height: 4px;
  width: 4px;
  margin: 2px;
  background-color: #FFFFFF;
  border-radius: 50%;
`

export const SitesFilterSearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 64px 32px 56px;
`

export const SitesFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const SitesFilterItemWrapper = styled.div`
  width: 184px;
  margin-right: 24px;
  border-radius: 4px;
  margin-top: 0;

  &:last-child {
    margin-right: 0;
  }
`

export const SitesToolbarActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 12px;
  min-width: 0;
  padding: 0 16px;
`

export const SiteTableCountryContainer = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-left: 8px;
  }
`

export const SitesTableIconsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SiteTableAssessmentIcon = styled.div`
  height: 36px;
  width: 36px;
  display: grid;
  place-items: center;
  border: none;
  background: none;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    border: none;
    background: #FFF;
  }

  &:hover svg path {
    fill-opacity: 1;
    text-align: center;
  }

  &:active {
    border-radius: 50%;
    border: none;
    background: #FFF;
  }
`

export const ViewActionStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SiteFilterValueWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const SitesSearchWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const SitesSearchInputWrapper = styled.div`
  width: 544px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 8px;
`
export const ResponsiveComponent = styled.div`
  flex-shrink: 0;

  @media screen and (max-width: 1199px) {
    width: 23rem;
    height: 2.5rem;
  }
`

// export const SitesSearchWrapper = styled.div`
//   display: flex;
//   align-items: center;
// `

// export const SitesSearchInputWrapper = styled.div`
//   width: 544px;
//   height: 40px;
//   border-radius: 4px;
//   display: flex;
//   align-items: center;
//   justify-content: flex-end;
//   margin-right: 8px;
//   margin-bottom: 2rem;
// `
// export const ResponsiveComponent = styled.div`
//   /* styles for all screen sizes */

//   /* styles for screen widths of 1122px and below */
//   @media screen and (max-width: 1199px) {
//     width: 23rem;
//     margin-bottom: 2rem;
//     height: 2.5rem;
//   }
// `
